import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { z } from "zod";

import { EmailLinkForm } from "~/components/auth/email-link-form";
import {
  AuthCard,
  AuthIntro,
  AuthLayout,
  AuthLinks,
} from "~/components/shell/auth-layout";
import { Callout } from "~/components/ui/callout";
import { TextButton } from "~/components/ui/text-button";
import { Note } from "~/components/ui/typography";
import { taglineFor } from "~/lib/brand";

const NOTICES = {
  verlopen: { tone: "info", text: "Je sessie is verlopen. Log opnieuw in." },
  "geen-account": {
    tone: "danger",
    text: "Er is geen account voor dit e-mailadres. Installateurs schrijven zich in via de aanmeldlink van hun partner.",
  },
} as const;

export const Route = createFileRoute("/(public)/inloggen/")({
  validateSearch: z.object({
    melding: z.enum(["verlopen", "geen-account"]).optional().catch(undefined),
  }),
  component: LoginPage,
});

function LoginPage() {
  const { melding } = Route.useSearch();
  const [sentTo, setSentTo] = useState<string | null>(null);
  const notice = melding ? NOTICES[melding] : null;

  if (sentTo !== null) {
    return (
      <AuthLayout>
        <AuthCard>
          <AuthIntro title="Check je e-mail">
            Als <b>{sentTo}</b> bij ons bekend is, ontvang je binnen een paar minuten een
            inloglink. Open de link op dit apparaat om direct in te loggen.
          </AuthIntro>
          <Note>Geen mail ontvangen? Kijk ook in je spammap.</Note>
        </AuthCard>
        <AuthLinks>
          <TextButton onClick={() => setSentTo(null)}>
            Ander e-mailadres gebruiken
          </TextButton>
        </AuthLinks>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <AuthCard>
        <AuthIntro title="Inloggen">
          {taglineFor(null)}. Vul je e-mailadres in, dan sturen we je een inloglink. Geen
          wachtwoord nodig.
        </AuthIntro>
        {notice ? <Callout tone={notice.tone}>{notice.text}</Callout> : null}
        <EmailLinkForm submitLabel="Stuur inloglink" onSent={setSentTo} />
      </AuthCard>
      <AuthLinks>
        <span>
          Installateur zonder account? Schrijf je in via de aanmeldlink van je partner.
        </span>
      </AuthLinks>
    </AuthLayout>
  );
}
